export default __webpack_public_path__ + "fba03030d7c82ee85c236ccccd4e8b09.png";